import request from '@/config/axios'

export interface LegalAssistantConfigVO {
  id?: number
  enabled: boolean
  mcpUrl: string
  modelId?: number | null
  title: string
  subtitle: string
  disclaimer: string
  systemPrompt: string
  maxToolRounds: number
}

export interface LegalAssistantToolVO {
  name: string
  description: string
  inputSchema: string
}

export interface LegalAssistantChatResultVO {
  content: string
  toolCount: number
  calledTools: string[]
  mcpUrl: string
  error: boolean
}

export const LegalAssistantConfigApi = {
  get: async (): Promise<LegalAssistantConfigVO | null> =>
    request.get({ url: '/ai/legal-assistant/config/get' }),
  save: async (data: LegalAssistantConfigVO): Promise<number> =>
    request.put({ url: '/ai/legal-assistant/config/save', data })
}

export const LegalAssistantChatApi = {
  chat: async (message: string): Promise<LegalAssistantChatResultVO> =>
    request.post({ url: '/ai/legal-assistant/chat', data: { message } }),
  tools: async (): Promise<LegalAssistantToolVO[]> =>
    request.get({ url: '/ai/legal-assistant/tools' }),
  health: async (): Promise<{ enabled: boolean; mcpUrl: string; ready: boolean; toolCount: number }> =>
    request.get({ url: '/ai/legal-assistant/health' })
}
